import { environment } from '@szte-griffin/environment'; // TODO move

// TODO move
export const apiUrl = `${environment.apiUrl}/admin-users/auth/`;
